var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 74,
    viewBox: "0 0 336 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.415 49.8659H284.494V49.8087L284.415 49.8659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.769 30.1886H123.291C123.291 30.1886 125.241 30.1886 125.241 32.0386H133.757C133.757 30.0894 133.757 24.1341 125.835 24.1341H103.988C96.0662 24.1341 96.0662 30.0894 96.0662 32.0386V42.0118C96.0662 43.9846 96.0662 49.8659 103.93 49.8659H133.482V34.0568H113.763V40.1114H125.561V43.9795H105.799C105.799 43.9795 103.819 43.9795 103.819 42.0455V32.0386C103.819 30.1886 105.769 30.1886 105.769 30.1886Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.75 24.1341L141.977 49.8659H149.831L153.495 43.9795H171.85L175.477 49.8659H183.368L167.595 24.1341H157.75ZM157.125 37.925L162.655 28.9374L168.218 37.925H157.125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.634 43.475L201.817 24.1341H191.966V49.8659H199.887V33.9004L209.743 49.8659H219.562L229.382 33.9004V49.8659H237.303V24.1341H227.452L214.634 43.475Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.101 49.8659H286.517V43.9795H257.022V40.1114H286.517V34.0568H257.022V30.1886H286.517V24.1341H249.101V49.8659Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.651 38.5153L335.73 30.1886V24.1341H298.314V30.1886H324.994L319.77 34.0568H298.314V49.8659H309.524L318.984 42.7636L326.09 49.8659H336L324.651 38.5153ZM305.396 44.8221V39.2721H312.831L305.398 44.8221H305.396Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1577 0H0V74H74.1577V0Z",
    fill: "#EF233C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5721 38.5153L55.652 30.1886V24.1341H18.236V30.1886H44.916L39.6912 34.0568H18.236V49.8659H29.4457L38.9058 42.7636L46.0115 49.8659H55.9216L44.5721 38.5153ZM25.3181 44.8221V39.2721H32.7524L25.3198 44.8221H25.3181Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.da08b59130b5f49c1fa4ebb848c8ee04.svg";
export { ForwardRef as ReactComponent };